import {equalTo} from './equal-to.directive';
import {betweenNumbers} from './between-numbers.directive';

export const ExtendedValidators: any = {
    equalTo,
    betweenNumbers
};
